import data from './data';

import { hexToDecimal, decimalToHex, clearData2D } from './helpers';

/*****************************************
 * EXPORTED FUNCTIONS
 *****************************************/

const calcFunctions = {
  clearData2D,
  data2DConvert2Draw,
  data2DrawConvert2Data2D,
  blend,
};

export default calcFunctions;

// set pixel in Canvas array format
function setPx(matrix, y, x, val) {
  y *= 4;
  x *= 4;
  matrix[y * data.size.width + x] = hexToDecimal(val, 0, 2);
  matrix[y * data.size.width + x + 1] = hexToDecimal(val, 2, 4);
  matrix[y * data.size.width + x + 2] = hexToDecimal(val, 4, 6);
  matrix[y * data.size.width + x + 3] = hexToDecimal(val, 6, 8);
}

// convert 2D matrix to Canvas format
function data2DConvert2Draw(data2D, repeat = 1) {
  const picMiddle = {
    width: (data2D.width * repeat) / 2,
    height: (data2D.height * repeat) / 2,
  };

  // const startX = Math.round(data.size.width / 2 - picMiddle.width);
  // const startY = Math.round(data.size.height / 2 - picMiddle.height);
  const startX = 0;
  const startY = 0;

  const dataDraw = clearDrawData();
  for (let i = 0; i < data2D.height * repeat; i++) {
    const iSrc = Math.floor(i / repeat);
    for (let j = 0; j < data2D.width * repeat; j++) {
      const jSrc = Math.floor(j / repeat);
      setPx(dataDraw, startY + i, startX + j, data2D[iSrc][jSrc]);
    }
  }
  return dataDraw;
}
function data2DrawConvert2Data2D(dataDraw, width, height) {
  // console.log(width, height)
  // console.table(dataDraw);
  const data2D = clearData2D({ width, height });
  for (let i = 0; i < height; i++) {
    for (let j = 0; j < width; j++) {
      let iSrc = (i * width + j) * 4;
      let val = '';
      for (let k = 0; k < 4; k++) {
        val += decimalToHex(dataDraw[iSrc + k]);
      }
      data2D[i][j] = val;
    }
  }
  data2D.width = width;
  data2D.height = height;
  return data2D;
}

/*****************************************
 * initializations
 *****************************************/

// all variables are declares in data.js

// data in Canvas format
function clearDrawData() {
  const data2Draw = new Array(data.size.height * data.size.width * 4).fill(255);
  return data2Draw;
}

/*****************************************
 * Modes
 *****************************************/
// const functions = [multiply, screen];

////////////////////////////////////

// function multiply(top, bot, el) {
//   // result in floating point
//   let temp = top[el] * bot[el];
//   temp = Math.min(1, temp);
//   temp = Math.max(0, temp);

//   // result in floating point

//   return temp;
// }

/////////////////////////////////////
// function screen(top, bot, el) {
//   let temp = 1 - (1 - top[el]) * (1 - bot[el]);
//   return temp;
// }

/////////////////////////////////////
/*
function specificFormula(arr, ...rest) {
  let temp = '';
  let res = '';
  arr.forEach(el => {
    temp += el;
    if (rest.length > 0) {
      temp += rest.shift();
    }
  });

  // console.log(temp);
  eval(temp);
  // console.log(temp);
  // console.log(res);
  return res;
}
*/

/*****************************************
 * Blending
 *****************************************/

async function blend(opacity, data2D, groupIdx, exampleIdx) {
  function extractRGB(val) {
    let res = {};
    const keys = ['R', 'G', 'B'];
    keys.forEach((el, idx) => {
      const hex = val.slice(idx * 2, idx * 2 + 2);
      res[el] = Number('0x' + hex) / 256;
    });

    res['A'] = val.slice(6, 8);
    return res; // in floating point for each RGB
  }

  await this.setState(prev => ({ busy: true }));
  // console.log(this.state.busy);

  let top = data2D[1];
  let bottom = data2D[0];

  // let blended = JSON.parse(JSON.stringify(bottom));

  // create matrix
  let blended = {};

  blended.width = bottom.width;
  blended.height = bottom.height;

  for (let i = 0; i < bottom.height; i++) {
    blended[i] = bottom[i].slice();
  }

  //////////////////////

  for (let i = 0; i < bottom.height; i++) {
    for (let j = 0; j < bottom.width; j++) {
      if (i < top.height && j < top.width) {
        let topVal = extractRGB(top[i][j]);
        let bottomVal = extractRGB(bottom[i][j]);

        blended[i][j] = formula(
          groupIdx,
          exampleIdx,
          topVal,
          bottomVal,
          opacity,
        );

        // let topVal = Number('0x' + top[i][j]);
        // let bottomVal = Number('0x' + bottom[i][j]);
        // let mixVal = Math.floor((topVal + bottomVal) / 2);
        // blended[i][j] = mixVal.toString(16);
      }
    }
  }
  const matrix = calcFunctions.data2DConvert2Draw(blended);

  this.setState(prev => ({ busy: false, matrix: matrix }));
}

/******************************************************* */
/*   FORMULA!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!    */
/******************************************************* */

////////////////////////////////////
function formula(groupIdx, exampleIdx, top, bot, x) {
  let temp = [];
  const keys = ['R', 'G', 'B'];
  keys.forEach(el => {
    temp[el] = specificFormula(top, bot, el, x, groupIdx, exampleIdx);
    temp[el] = Math.min(temp[el], 1);
    temp[el + 'n'] = temp[el];

    // convert to hex number from floating
    // temp= Math.min(temp,1);
    // temp = Math.floor(temp * 255);
    // temp = temp.toString(16).padStart(2, '0'); // 2 nibbles
    // res += temp; // concatenate RGB to one string
  });

  if (groupIdx ===0) {
    temp['Rn'] = Math.min(
      0.393 * temp['R'] + 0.769 * temp['G'] + 0.189 * temp['B'],
      1,
    );
    temp['Gn'] = Math.min(
      0.349 * temp['R'] + 0.686 * temp['G'] + 0.168 * temp['B'],
      1,
    );
    temp['Bn'] = Math.min(
      0.272 * temp['R'] + 0.534 * temp['G'] + 0.131 * temp['B'],
      1,
    );
  }
  if (groupIdx === 1) {
    ['Rn', 'Gn', 'Bn'].forEach(
      el =>
        (temp[el] =
          0.2126 * temp['R'] + 0.7152 * temp['G'] + 0.0722 * temp['B']),
    );
  }

  let res = '';
  ['Rn', 'Gn', 'Bn'].forEach(el => {
    temp[el] = Math.floor(temp[el] * 255);
    res += temp[el].toString(16).padStart(2, '0');
  });

  res += bot['A']; // for alpha
  return res;
}

/******************************************************* */
/*   DORON CHANGE!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!    */
/******************************************************* */

function specificFormula(top, bot, el, x, groupIdx, caseIdx) {
  let temp,
    opacityFlag = 1;
  const cases = {
    0: 0,
    1: 0,
    2: 0,
  };
  caseIdx = cases[groupIdx] + caseIdx;
 // ["A", "A*x", "1-(1-A)*x", "A*A", "A*(2-A)", "3A^2 - 2*A^3"],
  switch (caseIdx) {
    case 0:
      temp = bot[el]; //
      opacityFlag = 0;
      break;

    case 1:
      temp = bot[el] * x; //
      opacityFlag = 0;
      break;

    case 2:
      temp = 1 - (1 - bot[el]) * x; //
      opacityFlag = 0;
      break;

    case 3:
      temp = bot[el] * bot[el] * x + (1 - x) * bot[el]; //
      opacityFlag = 0;
      break;

    case 4:
      temp = bot[el] * (2 - bot[el]) * x + (1 - x) * bot[el]; //
      opacityFlag = 0;
      break;

    case 5:
      temp = bot[el] * bot[el] * (3 - 2 * bot[el]);
      temp = temp * x + (1 - x) * bot[el]; //
      opacityFlag = 0;
      break;
  }

  temp = Math.min(1, temp);
  temp = Math.max(0, temp);
  if (opacityFlag) {
    temp = bot[el] * (1 - x) + temp * x;
  }

  return temp;
}
